// Sorting utilities for VOD/Series lists

export const SORT_ORDERS = {
  ID_DESC: 'id_desc',
  ID_ASC: 'id_asc',
  AZ: 'az',
  ZA: 'za',
};

export function getDefaultVodSort() {
  try {
    const v = localStorage.getItem('vod-sort');
    return v || SORT_ORDERS.ID_DESC;
  } catch (_) {
    return SORT_ORDERS.ID_DESC;
  }
}

export function setVodSort(order) {
  try {
    localStorage.setItem('vod-sort', order);
  } catch (_) {}
}

export function pickId(item, isSeries) {
  return isSeries ? item.series_id : item.stream_id;
}

export function sortVodItems(items, order, isSeries) {
  if (!Array.isArray(items) || items.length === 0) return items || [];
  const safe = items.slice(0);
  switch (order) {
    case SORT_ORDERS.AZ:
      return safe.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    case SORT_ORDERS.ZA:
      return safe.sort((a, b) => (b.name || '').localeCompare(a.name || ''));
    case SORT_ORDERS.ID_ASC:
      return safe.sort((a, b) => (parseInt(pickId(a, isSeries)) || 0) - (parseInt(pickId(b, isSeries)) || 0));
    case SORT_ORDERS.ID_DESC:
    default:
      return safe.sort((a, b) => (parseInt(pickId(b, isSeries)) || 0) - (parseInt(pickId(a, isSeries)) || 0));
  }
}

// Future: category-specific preference keys
export function getVodCategorySort(categoryId) {
  if (!categoryId) return null;
  try {
    return localStorage.getItem(`vod-sort-cat-${categoryId}`);
  } catch (_) {
    return null;
  }
}

